import { Component, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { APP_BASE_HREF, Location } from '@angular/common';
import { AppBase } from '@common/app/app.component.base';
import { GoogleAnalyticsService } from '@common/services/google-analytics.service';
import { Title } from '@angular/platform-browser';
import { CommunityService } from '@common/services/community.service';
import { ContentService } from '@common/services/content.service';
import { SeoService } from '@common/services/seo.service';
import { KenalyticsService } from '@common/services/kenalytics.service';
import { ChatService } from '@common/services/chat.service';
import { AnalyticsService } from '@common/analytics/services/analytics.service';
import { WINDOW } from '@common/services/window.service';
import { AnalyticsClickService } from '@common/analytics/services/click.service';

@Component({
    selector: 'app-root',
    styleUrls: ['app.component.scss'],
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent extends AppBase implements OnInit {
    public cmsService: ContentService;

    constructor(
        router: Router,
        location: Location,
        analytics: GoogleAnalyticsService,
        titleService: Title,
        communityService: CommunityService,
        route: ActivatedRoute,
        contentService: ContentService,
        seoService: SeoService,
        kenalyticsService: KenalyticsService,
        private chat: ChatService,
        analyticsService: AnalyticsService,
        @Inject(WINDOW) window: Window,
        @Inject(APP_BASE_HREF) baseHref: string,
        clickService: AnalyticsClickService,
    ) {
        super(
            router,
            location,
            analytics,
            titleService,
            communityService,
            route,
            contentService,
            seoService,
            kenalyticsService,
            analyticsService,
            window,
            baseHref,
            clickService,
        );
        this.cmsService = contentService;
    }

    ngOnInit() {
        this.chat.likeIts1999('home');
        super.ngOnInit();
    }
}
